const toArray = x => (Array.isArray(x) ? x : x !== undefined ? [x] : []);

export { toArray };
